<template>
  <div class="container mb-3">
  <PHFCli/>
  </div>
</template>

<script>
import PHFCli from '../components/PHFCli.vue'
// import PhfSlide from '../components/PhfSlide.vue'
  export default {
    name: 'home',
    components:{
      PHFCli
      // PhfSlide
    }
  }
</script>
